module.exports = __webpack_public_path__ + "img/vendor-cover.54abffed.jpeg";